import { Component, OnInit } from '@angular/core';
import { WorkflowAssistantService } from './../../core/services/workflow-assistant.service';

@Component({
  selector: 'csi-workflow-assistant',
  templateUrl: './workflow-assistant.component.html',
  styleUrls: ['./workflow-assistant.component.css']
})
export class WorkflowAssistantComponent implements OnInit {
  public showSuggestionsDisplay = false;
  constructor(public workflowAssistantService: WorkflowAssistantService) {}

  ngOnInit() {}
}
